import GroupView from "@/components/GroupView";
import ProblemGravity from "@/pages/saas/ProblemGravity";
import OperationalGravity from "@/pages/saas/OperationalGravity";

export default function Gravites() {
  return (
    <GroupView
      groupKey="gravites"
      groupLabel="Gravités"
      overline="Module groupe · Diagnostic"
      tabs={[
        { slug: "problemes", label: "Problèmes (Politique)", Component: ProblemGravity },
        { slug: "piliers", label: "Piliers opérationnels (Systémique)", Component: OperationalGravity },
      ]}
    />
  );
}
